module.exports = __webpack_public_path__ + "static/media/image-gallery-4.0bb25c30.jpg";